import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cms-development',
  templateUrl: './cms-development.component.html',
  styleUrls: ['./cms-development.component.scss']
})
export class CmsDevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
